import { z } from "zod";

export type SubmitDocumentSuccessResponse = {
  data: {
    successMessage: string;
  };
};

export type SubmitDocumentErrorResponse = {
  data: {
    errorMessage: string;
  };
};
export type SubmitDocumentResponse =
  | SubmitDocumentSuccessResponse
  | SubmitDocumentErrorResponse;

export const SubmitDocumentResponseSchema = z.union([
  z.object({
    data: z
      .object({
        successMessage: z.string(),
      })
      .passthrough(),
  }),
  z.object({
    data: z
      .object({
        errorMessage: z.string(),
      })
      .passthrough(),
  }),
]);

export function checkIsSubmitDocumentErrorResponse(
  response: SubmitDocumentResponse
): response is SubmitDocumentErrorResponse {
  return "errorMessage" in response.data;
}
